import { AlertData } from "./types";

// alert_id をキー名とし、AlertData を返却する
// 同一警報 ID でも status によって文言が変わる場合があるため、詳細設計書を参照のこと
export function getAlertData(alertId: string, status?: 0 | 1 | 2): AlertData {
  return {
    OE00000001: {
      id: "OE00000001",
      msg: status === 2 ? "温度異常が出ています" : "温度超過しています"
    },
    OE00000002: {
      id: "OE00000002",
      msg: status === 2 ? "温度異常が出ています" : "温度超過しています"
    },
    OE00000003: {
      id: "OE00000003",
      msg: "電池残量が少なくなっています"
    },
    OE00000004: {
      id: "OE00000004",
      msg: "センサ異常　温度取得できません"
    }
  }[alertId];
}
